import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import * as v from '../../../helpers/validation';
import { Paper } from '@material-ui/core';
import classnames from 'classnames';
// SERVICES
import { createQaUser } from '../../../services';
import { DynamicForm } from '../../DynamicForm';

import {
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormGroup,
  Grid,
  TextField,
  Checkbox,
  Typography,
  RadioGroup,
  Radio,
} from '@material-ui/core';

const styles = props => ({ paper: { padding: '24px', boxSizing: 'border-box' } });

export const QaUsersCreate = withStyles(styles)(({ classes }) => {
  const qaUserInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'text',
              field: 'email',
              label: 'E-mail',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'userName',
              label: 'Username',
              validate: [v.required()],
            },
            {
              inputType: 'password',
              field: 'password',
              label: 'Password',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'name',
              label: 'Name',
              validate: [v.required()],
              disabledOnEdit: true,
            },
            {
              inputType: 'text',
              field: 'code',
              label: 'Code',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'workPhone',
              label: 'Work Phone',
              validate: [],
            },
            {
              inputType: 'text',
              field: 'homePhone',
              label: 'Home Phone',
              validate: [],
            },
            {
              inputType: 'text',
              field: 'cellPhone',
              label: 'Cell Phone',
              validate: [],
            },
            {
              inputType: 'text',
              field: 'fax',
              label: 'Fax',
              validate: [],
            },
            {
              inputType: 'select',
              field: 'recordType',
              label: 'Record Type',
              options: [
                { value: 'Active', label: 'Active' },
                { value: 'Inactive', label: 'Inactive' },
              ],
              validate: [v.checkRecordType('Record Type must be `Active` or `Inactive`')],
            },
          ],
        },
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'text',
              field: 'address',
              label: 'Address',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'city',
              label: 'City',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'state',
              label: 'State',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'zip',
              label: 'Zip',
              validate: [v.required()],
            },
            {
              inputType: 'textarea',
              field: 'notes',
              label: 'Additional Notes',
            },
          ],
        },
      ],
    },
  ];

  return (
    <Paper className={classnames(classes.paper, 'border-left-green')} elevation={1}>
      <DynamicForm inputs={qaUserInputs} mode={'CREATE'} onSave={createQaUser} redirectOnSuccess={'/users/qa'} />
    </Paper>
  );
});
